import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { WorkspaceFile } from '@common/workspace/models/workspace-file.model';
import { CollabPullDialogComponent, CollabPullDialogData } from '@portal-core/collab/components/collab-pull-dialog/collab-pull-dialog.component';
import { CurrentService } from '@portal-core/current/services/current.service';

@Component({
  selector: 'mc-workspace-pull-changes-bar',
  templateUrl: './workspace-pull-changes-bar.component.html',
  styleUrls: ['./workspace-pull-changes-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkspacePullChangesBarComponent implements OnChanges {
  @Input() branchName: string;
  @Input() licenseId: number;
  @Input() projectId: number;
  @Input() workspaceFiles: WorkspaceFile[];
  @Input() type: CollabPullDialogData['type'];

  @HostBinding('class.mc-hidden') _hidden: boolean = true;

  constructor(private currentService: CurrentService, private dialog: MatDialog) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.workspaceFiles) {
      this._hidden = !this.workspaceFiles?.some(workspaceFile => !!workspaceFile.remoteGitStatus);
    }
  }

  onPullChangesClicked() {
    const filePaths = this.workspaceFiles?.filter(workspaceFile => workspaceFile.remoteGitStatus)?.map(workspaceFile => workspaceFile.filePath);

    this.dialog.open<CollabPullDialogComponent, CollabPullDialogData>(CollabPullDialogComponent, {
      ...CollabPullDialogComponent.DialogConfig,
      data: {
        branchName: this.branchName,
        filePaths,
        licenseId: this.licenseId,
        projectId: this.projectId,
        type: this.type,
        userId: this.currentService.getUserId()
      }
    });
  }
}
